import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loading } from '@ibk/shared-ui';
import { useBenefitContract } from '../../hooks/useBenefitContract';
import { useNewBenefitHiringEligibility } from '../../hooks/useNewBenefitHiringEligibility';
export default function WithoutContractGuard({ children, redirectTo = '/beneficios' }) {
    const navigate = useNavigate();
    const { hasContract, isLoading: isLoadingContract, isError: isContractError, contractData } = useBenefitContract();
    const { isPatEnabled, isLoading: isLoadingEligibility, hasAllContractTypes, } = useNewBenefitHiringEligibility(contractData?.id ?? null);
    const isLoading = isLoadingContract || isLoadingEligibility;
    const hasAllContracts = isPatEnabled ? hasContract && hasAllContractTypes : hasContract;
    const shouldRedirect = isContractError || hasAllContracts;
    useEffect(() => {
        if (!isLoading && shouldRedirect) {
            navigate(redirectTo, { replace: true });
        }
    }, [isLoading, shouldRedirect, navigate, redirectTo]);
    if (isLoading) {
        return _jsx(Loading, { fullScreen: true });
    }
    if (shouldRedirect) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
}
